import { memo as Memo, useMemo, useState, useCallback, useRef, useEffect } from 'react';
import { gsap } from 'gsap';

//* Api
import api from '@/utils/api';

//* Components
import Form from '../Form';
import Text from '../Text';
import HTMLContainer from '../HTMLContainer';

//* Styles
import SubscribeStyle from './style';

const Subscribe = Memo(() => {
	//! States
	const [isSend, setIsSend] = useState(false);
	const [sendLoading, setsSendLoading] = useState(false);

	//! Refs
	const formRef = useRef();
	const heightRef = useRef();
	const heightRef2 = useRef();

	//! Form Object
	const obj = useMemo(() => {
		return {
			realTimeValidate: true,
			submitText: 'Subscribe',
			fields: {
				email: {
					fieldType: 'input',
					props: {
						value: '',
						required: true,
						type: 'email',
						placeholder: 'Email',
						autocomplete: 'off',
					},
				},
			},
		};
	}, []);

	useEffect(() => {
		if (heightRef2.current) {
			gsap.to(heightRef.current, 0, { height: heightRef2.current.clientHeight + 100 });
			gsap.to(heightRef2.current, 0, { marginTop: (heightRef2.current.clientHeight + 100) * -1 });
		}
	}, [heightRef2, heightRef]);

	//! Form Submit
	const onFormSubmit = useCallback((data) => {
		setsSendLoading(true);

		api.post('subscribe', data).then((res) => {
			setTimeout(() => {
				if (res.status === 'mail_sent') {
					setsSendLoading(false);
					formRef.current.resetFields();
					setIsSend(true);
				}
			}, 1000);
		});
	}, []);

	const successMessage = useMemo(
		() =>
			isSend && (
				<div className={`successMessage`}>
					<Text
						className={`h6 font-poppins font-light`}
						text={'thankYou'}
					/>
				</div>
			),
		[isSend]
	);

	return (
		<SubscribeStyle
			ref={heightRef}
			className={'subscribeCont'}>
			<div className={'subscribeTop'}>
				<div
					ref={heightRef2}
					className={'subscribeWrap'}>
					<HTMLContainer>
						<div className={'formWrap'}>
							<Text
								uppercase
								text={'subscribe'}
								className={`title p-m font-poppins font-medium`}
							/>

							<div className={`formCont ${sendLoading ? 'loading' : ''}`}>
								<Form
									ref={formRef}
									submit={onFormSubmit}
									className={'inputClass'}
									wrapContClass={'inputWrapClass'}
									{...obj}
								/>
							</div>

							{successMessage}
						</div>
					</HTMLContainer>
				</div>
			</div>
		</SubscribeStyle>
	);
});
export default Subscribe;
